(function () {
  'use strict';

  if (window.__ECLOOfferV6SuppParityLoaded) return;
  window.__ECLOOfferV6SuppParityLoaded = true;

  function q(scope, selector) { return scope ? scope.querySelector(selector) : null; }
  function qa(scope, selector) { return scope ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : []; }
  function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function cfg() { return window.ECLOOfferV6 || {}; }
  function detectMonths(value) {
    var text = String(value || '').toLowerCase();
    var match = text.match(/(\d+)\s*mois/) || text.match(/(\d+)\s*months?/) || text.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }
  function localeFor(root) {
    return String((root && root.dataset && root.dataset.locale) || document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  }
  function words(locale) {
    if (locale === 'en') return {
      choose: 'Choose my offer', oneTime: 'One-time purchase', subscription: 'Subscription', flexible: 'Flexible, no commitment',
      month: 'month', months: 'months', days: 'days', daysAverage: 'days on average', perDay: '/ day', freeShipping: 'Free shipping',
      save: 'Save', withSubscription: 'with subscription', noCommitment: 'No commitment', cancelAnytime: 'cancel anytime', add: 'Add to cart',
      saveMore: 'Save 15% extra', perOrder: 'per order', exclusive: 'Exclusive benefits', exclusiveTail: '(gifts, offers, exclusives…)',
      loyalty: 'Earn loyalty points', loyaltyTail: 'and unlock benefits'
    };
    if (locale === 'es') return {
      choose: 'Elegir mi oferta', oneTime: 'Compra única', subscription: 'Suscripción', flexible: 'Flexible, sin compromiso',
      month: 'mes', months: 'meses', days: 'días', daysAverage: 'días de media', perDay: '/ día', freeShipping: 'Envío gratis',
      save: 'Ahorra', withSubscription: 'con la suscripción', noCommitment: 'Sin compromiso', cancelAnytime: 'cancela cuando quieras', add: 'Añadir al carrito',
      saveMore: 'Ahorra un 15% adicional', perOrder: 'por pedido', exclusive: 'Ventajas exclusivas', exclusiveTail: '(regalos, ofertas, exclusividades…)',
      loyalty: 'Acumula puntos de fidelidad', loyaltyTail: 'y disfruta de ventajas'
    };
    return {
      choose: 'Choisir mon offre', oneTime: 'Achat unique', subscription: 'Abonnement', flexible: 'Flexible sans engagement',
      month: 'mois', months: 'mois', days: 'jours', daysAverage: 'jours en moyenne', perDay: '/ jour', freeShipping: 'Livraison offerte',
      save: 'Économisez', withSubscription: 'avec l’abonnement', noCommitment: 'Sans engagement', cancelAnytime: 'résiliable à tout moment', add: 'Ajouter au panier',
      saveMore: 'Économisez 15 % supplémentaires', perOrder: 'par commande', exclusive: 'Avantages exclusifs', exclusiveTail: '(cadeaux, promos, exclusivités…)',
      loyalty: 'Cumulez des points fidélité', loyaltyTail: 'et profitez d’avantages'
    };
  }
  function money(cents, currency, locale) {
    var amount = Number(cents || 0);
    var numberLocale = locale === 'en' ? 'en-GB' : (locale === 'es' ? 'es-ES' : 'fr-FR');
    try {
      return new Intl.NumberFormat(numberLocale, {
        style: 'currency', currency: currency || 'EUR', minimumFractionDigits: amount % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(amount / 100);
    } catch (error) { return (amount / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function track(eventName, params) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: eventName }, params || {})); } catch (error) {}
  }

  function compactFormula(block) {
    if (!block || block.dataset.ecloSuppV6FormulaCompact === 'true') return;
    var title = clean(q(block, '.eclo-supplement-hero-actives__eyebrow') && q(block, '.eclo-supplement-hero-actives__eyebrow').textContent) || 'Le cœur de la formule';
    var rows = [];

    qa(block, '.eclo-supplement-hero-active').forEach(function (card) {
      var brandNode = q(card, '.eclo-supplement-hero-active__brand');
      var brand = clean(brandNode && brandNode.textContent);
      if (!brand && brandNode) {
        var image = q(brandNode, 'img');
        brand = clean(image && image.getAttribute('alt'));
      }
      var doseNode = q(card, '.eclo-supplement-hero-active__dose');
      var noteNode = q(card, '.eclo-supplement-hero-active__note');
      var detail = [clean(doseNode && doseNode.textContent), clean(noteNode && noteNode.textContent)].filter(Boolean).join(' · ');
      if (brand || detail) rows.push({ strong: brand || detail, detail: brand ? detail : '' });
    });

    var balance = q(block, '.eclo-supplement-hero-balance');
    if (balance) {
      var eyebrowNode = q(balance, '.eclo-supplement-hero-balance__eyebrow');
      var titleNode = q(balance, 'strong');
      var noteNode = q(balance, '.eclo-supplement-hero-balance__note');
      var eyebrow = clean(eyebrowNode && eyebrowNode.textContent);
      var balanceTitle = clean(titleNode && titleNode.textContent);
      var note = clean(noteNode && noteNode.textContent);
      var strong = note ? (balanceTitle || eyebrow) : (eyebrow || balanceTitle);
      var detail = note || (eyebrow && balanceTitle ? balanceTitle : '');
      if (strong || detail) rows.push({ strong: strong || detail, detail: strong ? detail : '' });
    }

    rows = rows.slice(0, 3);
    if (!rows.length) return;
    block.dataset.ecloSuppV6FormulaCompact = 'true';
    /* Prevent Régénère historical F renderers from replacing the shared compact formula. */
    block.setAttribute('data-regenere-summary-f', 'true');
    block.classList.add('eclo-supp-v6-formula-compact');
    block.innerHTML = '<h3 class="eclo-supp-v6-formula__title">' + esc(title) + '</h3>' +
      '<ul class="eclo-supp-v6-formula__rows">' + rows.map(function (row) {
        return '<li><strong>' + esc(row.strong) + '</strong>' + (row.detail ? '<span>—</span><em>' + esc(row.detail) + '</em>' : '') + '</li>';
      }).join('') + '</ul>';
  }

  function compactAllFormulae() {
    qa(document, '.eclo-supplement-hero-actives--v11').forEach(compactFormula);
  }

  function selectorsFor(root) {
    if (root && root.matches('[data-regenere-offer-test]')) {
      return {
        data: '[data-regenere-data]',
        tiers: '[data-regenere-tiers]',
        modes: '[data-regenere-modes]',
        ctaText: '[data-regenere-cta-text]'
      };
    }
    return {
      data: '[data-eclo-supp-data-v15]',
      tiers: '[data-eclo-supp-tiers-v15]',
      modes: '[data-eclo-supp-modes-v15]',
      ctaText: '[data-eclo-supp-cta-text-v15]'
    };
  }

  function createController(root) {
    var selectors = selectorsFor(root);
    var dataNode = q(root, selectors.data);
    if (!dataNode) return null;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return null; }
    var tiers = (data.variants || []).map(function (variant) { return { months: detectMonths(variant.title), variant: variant }; })
      .sort(function (a, b) { return a.months - b.months; });
    if (!tiers.length) return null;

    var locale = localeFor(root);
    var copy = words(locale);
    var country = String(root.dataset.country || '').toUpperCase();
    var shippingThreshold = parseInt(root.dataset.freeShippingThreshold || '5000', 10);

    function tierFor(months) {
      for (var i = 0; i < tiers.length; i += 1) if (tiers[i].months === months) return tiers[i];
      return tiers[0];
    }
    function planFor(tier) {
      var plans = tier && tier.variant && tier.variant.plans ? tier.variant.plans : [];
      if (!plans.length) return null;
      if (plans.length === 1) return plans[0];
      for (var i = 0; i < plans.length; i += 1) if (detectMonths(plans[i].name) === tier.months) return plans[i];
      return plans[0];
    }
    function one(months) { return Number(tierFor(months).variant.price || 0); }
    function sub(months) { var plan = planFor(tierFor(months)); return plan ? Number(plan.price || 0) : one(months); }

    var first = tierFor(1);
    var firstPrice = Number(first.variant.price || 0);
    var firstCompare = Number(first.variant.compareAtPrice || first.variant.compare_at_price || 0);
    var regularUnit = firstCompare > firstPrice ? firstCompare : firstPrice;

    function full(months) { return regularUnit * months; }
    function current(months, mode) { return mode === 'subscription' ? sub(months) : one(months); }
    function pct(base, value) { return base > value && base > 0 ? Math.round(((base - value) / base) * 100) : 0; }
    function subPct(months) { return pct(one(months), sub(months)); }

    function state() {
      var tierButton = q(root, selectors.tiers + ' [data-months].is-selected');
      var modeButton = q(root, selectors.modes + ' [data-mode].is-selected');
      var months = tierButton ? parseInt(tierButton.getAttribute('data-months') || '1', 10) : 1;
      if ([1, 2, 3].indexOf(months) < 0) months = 1;
      return { months: months, mode: modeButton && modeButton.getAttribute('data-mode') === 'subscription' ? 'subscription' : 'onetime' };
    }

    function select(months, mode) {
      var tierButton = q(root, selectors.tiers + ' [data-months="' + months + '"]');
      if (tierButton && !tierButton.disabled && !tierButton.classList.contains('is-selected')) tierButton.click();
      if (mode === 'subscription' && !planFor(tierFor(months))) mode = 'onetime';
      var modeButton = q(root, selectors.modes + ' [data-mode="' + mode + '"]');
      if (modeButton && !modeButton.disabled && !modeButton.classList.contains('is-selected')) modeButton.click();
    }

    function monthLabel(months) { return months + ' ' + (months === 1 ? copy.month : copy.months); }
    function meta(months, value) { return cfg().showDailyPrice ? money(value / (months * 30), data.currency, locale) + ' ' + copy.perDay : (months * 30) + ' ' + copy.days; }
    function priceHtml(months, mode, className) {
      var value = current(months, mode), benchmark = full(months);
      return '<span class="' + className + '">' + (benchmark > value ? '<s>' + esc(money(benchmark, data.currency, locale)) + '</s>' : '') + '<b>' + esc(money(value, data.currency, locale)) + '</b></span>';
    }
    function card(months, mode, selectedState) {
      var value = current(months, mode), discount = pct(full(months), value), tier = tierFor(months);
      var unavailable = tier.variant.available === false || (mode === 'subscription' && !planFor(tier));
      return '<button type="button" class="eclo-supp-v6-parity__card' + (selectedState.months === months ? ' is-selected' : '') + '" data-eclo-supp-v6-months="' + months + '"' +
        (unavailable ? ' disabled aria-disabled="true"' : '') + '>' +
        (discount ? '<span class="eclo-supp-v6-parity__badge">−' + discount + '%</span>' : '') +
        '<span class="eclo-supp-v6-parity__card-title">' + esc(monthLabel(months)) + '</span>' +
        '<span class="eclo-supp-v6-parity__card-meta">' + esc(meta(months, value)) + '</span>' +
        priceHtml(months, mode, 'eclo-supp-v6-parity__price') +
        (country !== 'SG' && value >= shippingThreshold ? '<span class="eclo-supp-v6-parity__shipping">' + esc(copy.freeShipping) + '</span>' : '') + '</button>';
    }
    function cards(mode, selectedState) { return '<div class="eclo-supp-v6-parity__cards">' + [1, 2, 3].map(function (m) { return card(m, mode, selectedState); }).join('') + '</div>'; }
    function top(selectedState) {
      return '<div class="eclo-supp-v6-parity__top"><strong>' + esc(copy.choose) + '</strong><span>' + esc((selectedState.months * 30) + ' ' + copy.daysAverage) + '</span></div>';
    }
    function toggle(selectedState) {
      var extra = subPct(selectedState.months) || subPct(1) || 15;
      return '<button type="button" class="eclo-supp-v6-parity__subscription' + (selectedState.mode === 'subscription' ? ' is-selected' : '') + '" data-eclo-supp-v6-subscription role="switch" aria-checked="' + (selectedState.mode === 'subscription' ? 'true' : 'false') + '">' +
        '<span class="eclo-supp-v6-parity__checkbox" aria-hidden="true"></span><span><strong>' + esc(copy.save) + ' −' + extra + '% ' + esc(copy.withSubscription) + '</strong>' +
        '<small>' + esc(copy.noCommitment) + ', ' + esc(copy.cancelAnytime) + '</small></span></button>';
    }
    function benefits() {
      return '<div class="eclo-v6__benefits eclo-supp-v6-parity__benefits">' +
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>' + esc(copy.saveMore) + '</strong> ' + esc(copy.perOrder) + '</span></div>' +
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>' + esc(copy.exclusive) + '</strong> ' + esc(copy.exclusiveTail) + '</span></div>' +
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>' + esc(copy.loyalty) + '</strong> ' + esc(copy.loyaltyTail) + '</span></div>' +
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>' + esc(copy.noCommitment) + '</strong>, ' + esc(copy.cancelAnytime) + '</span></div>' +
        '</div>';
    }
    function renderD(selectedState) { return top(selectedState) + '<div class="eclo-supp-v6-parity__panel">' + cards(selectedState.mode, selectedState) + toggle(selectedState) + '</div>'; }
    function rail(mode, selectedState) {
      var selected = selectedState.mode === mode;
      var extra = subPct(selectedState.months) || subPct(1) || 15;
      var label = mode === 'subscription' ? copy.subscription : copy.oneTime;
      var subline = mode === 'subscription' ? copy.flexible + ' · −' + extra + '%' : '';
      var body = '';
      if (selected) {
        body = cards(mode, selectedState);
        if (mode === 'subscription') body += benefits();
      }
      return '<section class="eclo-supp-v6-parity__mode' + (selected ? ' is-selected' : '') + '"><button type="button" class="eclo-supp-v6-parity__mode-head" data-eclo-supp-v6-mode="' + mode + '">' +
        '<span class="eclo-supp-v6-parity__radio"></span><span class="eclo-supp-v6-parity__mode-copy"><strong>' + esc(label) + '</strong>' + (subline ? '<small>' + esc(subline) + '</small>' : '') + '</span>' +
        priceHtml(selectedState.months, mode, 'eclo-supp-v6-parity__mode-price') + '</button>' + body + '</section>';
    }
    function renderA(selectedState) { return top(selectedState) + '<div class="eclo-supp-v6-parity__accordion">' + rail('onetime', selectedState) + rail('subscription', selectedState) + '</div>'; }

    function updateCta(selectedState) {
      var ctaText = q(root, selectors.ctaText);
      if (!ctaText) return;
      var value = current(selectedState.months, selectedState.mode), benchmark = full(selectedState.months);
      ctaText.innerHTML = '<span class="eclo-v6__cta-left">' + esc(copy.add) + '</span><span class="eclo-v6__cta-price"><b>' + esc(money(value, data.currency, locale)) + '</b>' +
        (benchmark > value ? '<s>' + esc(money(benchmark, data.currency, locale)) + '</s>' : '') + '</span>';
    }

    function mount() {
      var node = q(root, '[data-eclo-supp-v6-parity]');
      if (node) return node;
      var shared = q(root, '[data-eclo-offer-v6]');
      if (!shared) return null;
      node = document.createElement('div');
      node.className = 'eclo-supp-v6-parity';
      node.setAttribute('data-eclo-supp-v6-parity', '');
      shared.insertAdjacentElement('afterend', node);
      return node;
    }

    function bind(node) {
      qa(node, '[data-eclo-supp-v6-months]').forEach(function (button) {
        button.addEventListener('click', function () {
          var before = state(), months = parseInt(button.getAttribute('data-eclo-supp-v6-months') || '1', 10);
          select(months, before.mode); render();
          var after = state();
          track('eclo_offer_v6_select', { offer_version: 'v6', offer_style: cfg().layout || cfg().style || 'f3', product_key: cfg().product || 'supplement', purchase_mode: after.mode === 'subscription' ? 'sub' : 'onetime', tier_months: after.months, interaction_source: 'duration' });
        });
      });
      qa(node, '[data-eclo-supp-v6-mode]').forEach(function (button) {
        button.addEventListener('click', function () {
          var before = state(), mode = button.getAttribute('data-eclo-supp-v6-mode') === 'subscription' ? 'subscription' : 'onetime';
          select(before.months, mode); render();
          var after = state();
          track('eclo_offer_v6_select', { offer_version: 'v6', offer_style: cfg().layout || cfg().style || 'f3', product_key: cfg().product || 'supplement', purchase_mode: after.mode === 'subscription' ? 'sub' : 'onetime', tier_months: after.months, interaction_source: 'purchase-mode' });
        });
      });
      var subscriptionButton = q(node, '[data-eclo-supp-v6-subscription]');
      if (subscriptionButton) subscriptionButton.addEventListener('click', function () {
        var before = state(); select(before.months, before.mode === 'subscription' ? 'onetime' : 'subscription'); render();
        var after = state();
        track('eclo_offer_v6_select', { offer_version: 'v6', offer_style: cfg().layout || cfg().style || 'f3', product_key: cfg().product || 'supplement', purchase_mode: after.mode === 'subscription' ? 'sub' : 'onetime', tier_months: after.months, interaction_source: 'subscription-toggle' });
      });
    }

    function render() {
      locale = localeFor(root); copy = words(locale);
      var layout = String(cfg().layout || 'f3').toLowerCase();
      if (['f3', 'f4', 'f', 'a', 'd'].indexOf(layout) < 0) layout = 'f3';
      root.classList.remove('eclo-offer-v6-layout-f3', 'eclo-offer-v6-layout-f4', 'eclo-offer-v6-layout-f', 'eclo-offer-v6-layout-a', 'eclo-offer-v6-layout-d');
      root.classList.add('eclo-offer-v6-layout-' + layout);
      var node = mount();
      if (!node) return false;
      var selectedState = state();
      if (layout === 'a') { node.hidden = false; node.innerHTML = renderA(selectedState); bind(node); updateCta(selectedState); }
      else if (layout === 'd') { node.hidden = false; node.innerHTML = renderD(selectedState); bind(node); updateCta(selectedState); }
      else { node.hidden = true; node.innerHTML = ''; }
      return true;
    }

    return { render: render };
  }

  var attempts = 0;
  function init() {
    /* Formula compaction is independent from the active offer renderer. */
    compactAllFormulae();
    if (!cfg().enabled) return;

    var roots = qa(document, '[data-regenere-offer-test], [data-eclo-supp-offer-v15]');
    var waiting = !roots.length;
    roots.forEach(function (root) {
      if (!root.__ecloSuppV6Parity) root.__ecloSuppV6Parity = createController(root);
      if (!root.__ecloSuppV6Parity || !root.__ecloSuppV6Parity.render()) waiting = true;
    });
    if (waiting && attempts++ < 80) window.setTimeout(init, 75);
  }
  function refresh() { attempts = 0; window.setTimeout(init, 0); }

  window.ECLOOfferV6SuppParity = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('eclo:offer-v6-config', refresh);
  document.addEventListener('eclo:offer-v6-refresh', refresh);
})();
